import { Strategies } from 'types/entities'

import { LabelContent, HightlightText } from './Style'

export const options = [
  {
    icon: 'metamask',
    value: Strategies.EXTERNAL_WALLET,
    label: () => {
      return (
        <LabelContent>
          <HightlightText type='orange'>Metamask</HightlightText>
          <br />
          (might be slow)
        </LabelContent>
      )
    },
    tooltip: () => {
      return (
        <>
          We highly recommend to use <HightlightText type='green'>Self-generated key</HightlightText> option since your
          wallet can be slow and does not always function properly.
        </>
      )
    },
  },
  {
    icon: 'key',
    value: Strategies.SELF_GENERATED,
    label: () => {
      return (
        <LabelContent>
          <HightlightText type='green'>Self-generated</HightlightText>
          <br />
          (recommended)
        </LabelContent>
      )
    },
    tooltip: () => {
      return (
        <>
          This is the fastest recommended way to use <HightlightText type='green'>_mad-assembly</HightlightText>. The
          dApp generates a burner key on your device.
          <br />
          <br />
          After the burner key receives the funds, it will automatically post all your transactions on the blockchain.
        </>
      )
    },
  },
]
